import React, { useEffect, useState } from 'react';
import { Star, Clock, User, Play, Heart, ChevronRight, ShoppingBag, ShoppingCart, PersonStanding, UserRoundCheck, ClockArrowUp, LanguagesIcon, Laptop2, Croissant, Trash2 } from 'lucide-react';

import fallback_img from "./img/fallback_img.jpg"

import loading_img from "./img/loadingImg.jpg"

import CartSidebar from '../Cart/CartSidebar';

/**
 * CourseCard
 * A sleek, responsive course card built with Tailwind CSS.
 * Props:
 *  - course: {
 *      id, title, subtitle, author, duration (e.g. '3h 20m'),
 *      lessons (number), rating (0-5), reviews (number),
 *      image (url), tags: string[], price (string - 'Free' or '₹199'),
 *      progress (0-100) optional
 *    }
 *  - onEnroll(courseId)
 *  - layout: 'compact' | 'regular' (optional)
 *
 * Default export is the component. This file uses Tailwind utility classes.
 */

export default function CourseCardMinimalCart({removeItem,courseThemeCard1Object,sendBackPopUpItem, setCartOpen, course,item, onEnroll = () => {}, layout = 'regular',index }) {
  let targetDate =item?.course?.price?.pricePlan?.expiryStartDate?JSON.parse(item?.course?.price?.pricePlan?.expiryStartDate)?.selected?.to:"";

 const [timeLeft, setTimeLeft] = useState({
    days: 0, hours: 0, mins: 0, secs: 0,
  });
 
  useEffect(() => {
    const timer = setInterval(() => {
      const diff = new Date(targetDate) - new Date();
      if (diff <= 0) return clearInterval(timer);

      setTimeLeft({
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
        mins: Math.floor((diff / (1000 * 60)) % 60),
        secs: Math.floor((diff / 1000) % 60),
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  const {
    id,
    title = item?.course?.productName,
    subtitle = '',
    author = 'Unknown',
    duration = '10 Min',
    lessons = 1,
    rating = 1,
    reviews = 1,
    image = 'https://picsum.photos/400/550?random=50'+item?.course?.ID,
    tags = [""],
    price = "Free"
,
    progress = 10,
  } = course || {};
  // useEffect(()=>{console.log(item)},[])
  const showProgress = typeof progress === 'number' && progress >= 0 && progress <= 100;
const ImageFallFB = ({ itemOuter,boxShadow,src,width,aspectRatio, borderRadius,border,paddingLeft,paddingRight}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  
     
          const [reloadItems, setReloadItems] = useState(true);
         
             useEffect(()=>{
                 setReloadItems(false); setReloadItems(true);
                 
             },[ ])

               
  return (
    <div style={{ position: "relative",boxShadow:boxShadow,
    overflow: "hidden",aspectRatio: aspectRatio,padding:"0px",border:border, 
     borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
              
    width:`${width}%`}}  className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}>
      {!isLoaded && !hasError && (
        <div
         style={
             { 
              borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
      aspectRatio: aspectRatio,
      objectFit: "cover",  }}
       className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
        >
          <img
        src={loading_img}
        alt=""
      
       style={
             {
             borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
              
                position: "absolute",border:border,
      top: 0,
      left: 0,
      width: `${width}%`,padding:"10px",
    
      objectFit: "cover", aspectRatio: aspectRatio,  }}
       className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
      />
        </div>
      )}
      
      <img

      
        src={hasError ? fallback_img : src}
        alt=""
        onLoad={() => setIsLoaded(true)}
        onError={() => setHasError(true)}
       style={
             {
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
     
      objectFit: "cover",aspectRatio: aspectRatio  }}
       className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
      />
    </div>
  );
};
  return (

    <>   
    

      <div className="ty-cart-card">
   <article className={`course-card-cart course-card-cart--compact`} aria-labelledby={`course-${id}-title`}>
    <button className="course-card-cart__cart" onClick={() => {removeItem(item)}} style={{width:"30px",height:"30px",position:"absolute",top:"2px",right:"2px"}}><Trash2 size={20} color={courseThemeCard1Object?.wishListCartBtn?.iconColor?.color?courseThemeCard1Object?.wishListCartBtn?.iconColor?.color:"#444444"} /></button>

    
{item?.course?.typeLabel?<div className="courseCardLabelTags">{JSON.parse(item?.course?.typeLabel)?.post_title}</div>:""}
  {item?.course?.typeLabel?<div className="courseCardAllStatusLabel">{JSON.parse(item?.course?.statusLabel)?.post_title}</div>:""}
 
<div className="course-card-cart__media">


 <ImageFallFB  boxShadow={``}
                  src={image}
                  border={``}
                  width={ 100
                  }
                  aspectRatio={"4/3"
                  }
                  borderRadius={ courseThemeCard1Object?.image?.borderRadius
                  }/>
         
{!courseThemeCard1Object?.compact?.status?"":""}


</div>


<div className="course-card-cart__body">
<header>

{courseThemeCard1Object?.compact?.status?<div className="course-card-cart__tags" style={{position:"relative",top:"50px"}}>
{/* {tags?.map((t) => (
<span key={t} className="course-card-cart__tag" >{t}</span>
))} */}
</div>:""}
</header>
<div className=""style={{marginTop:"20px"}}>
{timeLeft.days?tags?.map((t) => (
<span key={t} className="course-card-cart__tag" style={{display:"flex",justifyContent:"left",gap:"5px"}}> 
            <div style={{display:"flex",justifyContent:"left",gap:"1px"}} ><span>{timeLeft.days}</span><span>Day</span></div>
            <div style={{display:"flex",justifyContent:"left",gap:"1px"}}><span>{timeLeft.hours}</span><span>Hrs</span></div>
            <div style={{display:"flex",justifyContent:"left",gap:"1px"}}><span>{timeLeft.mins}</span><span>Min</span></div>
            <div style={{display:"flex",justifyContent:"left",gap:"1px"}}><span>{timeLeft.secs}</span><span>Sec</span></div>
          </span>
)):""}
</div>
<div className="course-card-cart__meta">
<div className="course-card-cart__meta-left">

                           </div>
               </div>
{/* 
              
<div className="course-card-cart__meta-left">
{<div className="course-card-cart__meta-item"><UserRoundCheck size={20} color={courseThemeCard1Object?.courseTitle?.subtitleColor?.color} /> <span>{author}</span></div>}
<div className="course-card-cart__meta-item"><ClockArrowUp size={20} color={courseThemeCard1Object?.courseTitle?.subtitleColor?.color} /> <span>{duration}</span></div>

<div className="course-card-cart__rating"> <div><Star size={20} color={courseThemeCard1Object?.courseTitle?.subtitleColor?.color} /> </div> <div>{rating.toFixed(1)} <small>({reviews})</small></div></div>
</div> */}



<div>
<div className="course-card-cart__price"style={{marginTop:"20px"}}> <span style={{ fontSize:"25px", color:"rgba(20, 17, 17, 1)"}}>{item?.course?.price?.pricePlan?.effectivePriceWeb?item?.course?.price?.pricePlan?.effectivePriceWeb:"Free"}</span>
   <span>{item?.course?.price?.pricePlan?.currencySymbol}</span>  <span style={{fontSize:"10px",  color:"rgba(255,114,94,1)",textDecoration:"line-through",position:"relative",top:"-10px"}}>{item?.course?.price?.pricePlan?.regularPriceWeb?item?.course?.price?.pricePlan?.regularPriceWeb+" "
    +item?.course?.price?.pricePlan?.currencySymbol:""}</span></div>
{/* <div className="course-card-cart__lessons">{lessons} lessons</div> */}
</div>

</div>

<footer className="course-card-cart__footer" style={{position:"relative",display:"flex",flexWrap:"wrap",justifyContent:"left",top:"-10px"}}>
 
 
<div className="" style={{display:"flex",justifyContent:"left",flexWrap:"wrap",}} >
  <div className="course-card-cart__meta-item" style={{flexWrap:"wrap",width:"300px"}}>
            {item?.course?.languageLabel?<><LanguagesIcon size={14} color={courseThemeCard1Object?.tags?.buttonBG?.color} />   <div className="courseCardCartLanguageLabel ">
               {JSON.parse(item?.course?.languageLabel)?.post_title}</div></>:""}
             {item?.course?.difficultyLabel?<>  <Croissant size={14} color={courseThemeCard1Object?.tags?.buttonBG?.color} /><div className="courseCardCartDifficultyLabel">{JSON.parse(item?.course?.difficultyLabel)?.post_title}</div></>:""}
              
              </div>
  <div  className="course-card-cart__title" style={{width:"290px",textAlign:"left"}}>{title}</div>
</div>
<div>
</div>
</footer><div style={{display:"flex",justifyContent:"right",gap:"7px",marginTop:"65px"}}>
<button className="course-card-cart__cta" onClick={() => {}}><button className="course-card-cart__wishlist" onClick={() => {}}style={{width:"35px",height:"35px",}}><Heart size={20} color={courseThemeCard1Object?.wishListCartBtn?.iconColor?.color?courseThemeCard1Object?.wishListCartBtn?.iconColor?.color:"#444444"} /></button>
Move To Wishlist</button>
</div>
</article></div>

  <style>{`

    :root{
  --card-bg: 
  --card-border: #e6e9ee;
  --muted: #6b7280;
  --accent: #7c3aed; /* violet */
  --accent-2: #06b6d4; /* teal */
  --radius: 16px;
}

.course-card-cart{
  display: grid;margin-right:15px;position:relative;
 padding:5px;
 width:100%;
  background: ${courseThemeCard1Object?.layoutCard?.layoutBG?.color};;
   border:${courseThemeCard1Object?.layoutCard?.borderCard?.borderWidth?.value}px ${courseThemeCard1Object?.layoutCard?.borderCard?.borderType} ${courseThemeCard1Object?.layoutCard?.borderCard?.borderColor?.color};
           border-top-left-radius:${courseThemeCard1Object?.layoutCard?.borderRadius?.topLeft?.value+"px"};
    border-bottom-left-radius:${courseThemeCard1Object?.layoutCard?.borderRadius?.bottomLeft?.value+"px"};
    border-top-right-radius:${courseThemeCard1Object?.layoutCard?.borderRadius?.topRight?.value+"px"};
    border-bottom-right-radius:${courseThemeCard1Object?.layoutCard?.borderRadius?.bottomRight?.value+"px"};
 
  box-shadow:${courseThemeCard1Object?.layoutCard?.layoutShadow?.horizontal?.value}px ${courseThemeCard1Object?.layoutCard?.layoutShadow?.vertical?.value}px ${courseThemeCard1Object?.layoutCard?.layoutShadow?.blur?.value}px ${courseThemeCard1Object?.layoutCard?.layoutShadow?.spread?.value}px ${courseThemeCard1Object?.layoutCard?.layoutShadow?.shadowColor?.color} ${courseThemeCard1Object?.layoutCard?.layoutShadow?.inset?"inset":""};
        
  
}

.course-card-cart--compact{
  grid-template-columns: 120px 1fr;
}

.course-card-cart__media{
  position: relative;margin-top:10px;
 
}

.course-card-cart--compact .course-card-cart__media{
  height: auto;margin-top:30px;
}

.course-card-cart__image{
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.course-card-cart__tags{
  position: absolute;
  left: 2px;top:2px;
  margin-top: 2px;margin-bottom:2px;
  display: flex;flex-wrap:wrap;
  gap: 5px;
}

.course-card-cart__tag{
  background: ${courseThemeCard1Object?.tags?.buttonBG?.color};
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 9px; 
  color: ${courseThemeCard1Object?.courseTitle?.tagsColor?.color};
  font-family:${courseThemeCard1Object?.courseTitle?.titleFont?.family?.fontFamily};;
  border:${courseThemeCard1Object?.tags?.border?.borderWidth?.value}px ${courseThemeCard1Object?.tags?.border?.borderType} ${courseThemeCard1Object?.tags?.border?.borderColor?.color};
     border-top-left-radius:${courseThemeCard1Object?.tags?.borderRadius?.topLeft?.value+"px"};
    border-bottom-left-radius:${courseThemeCard1Object?.tags?.borderRadius?.bottomLeft?.value+"px"};
    border-top-right-radius:${courseThemeCard1Object?.tags?.borderRadius?.topRight?.value+"px"};
    border-bottom-right-radius:${courseThemeCard1Object?.tags?.borderRadius?.bottomRight?.value+"px"};

  box-shadow: 0 2px 6px rgba(2,6,23,0.06);
}

.course-card-cart__enroll-btn{
  position: absolute; display:flex; justify-content:space-between;
  right: 12px;
  bottom: 12px;
  background: ${courseThemeCard1Object?.showMoreBtn?.btnColor?.color};;
  border:${courseThemeCard1Object?.showMoreBtn?.border?.borderWidth?.value}px ${courseThemeCard1Object?.showMoreBtn?.border?.borderType} ${courseThemeCard1Object?.showMoreBtn?.border?.borderColor?.color};
  
  padding: 8px 12px; border-top-left-radius:${courseThemeCard1Object?.showMoreBtn?.borderRadius?.topLeft?.value+"px"};
    border-bottom-left-radius:${courseThemeCard1Object?.showMoreBtn?.borderRadius?.bottomLeft?.value+"px"};
    border-top-right-radius:${courseThemeCard1Object?.showMoreBtn?.borderRadius?.topRight?.value+"px"};
    border-bottom-right-radius:${courseThemeCard1Object?.showMoreBtn?.borderRadius?.bottomRight?.value+"px"};
 
  color: ${courseThemeCard1Object?.showMoreBtn?.iconColor?.color};
  font-family:${courseThemeCard1Object?.courseTitle?.metaFont?.family?.fontFamily};;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 6px 14px rgba(2,6,23,0.08);
}

.course-card-cart__body{
  padding: 16px;
}
.courseCardLabelTags {
    background: ${courseThemeCard1Object?.tags?.buttonBG?.colors?.color1};;font-family: Montserrat !important;
    opacity: 1;text-align: left;
    display: inline-block;
    position: absolute;
    top: 0px;
    left: 0px;
    text-transform: uppercase;
    color: #fff;
    font-size: 10px;
    font-weight: 700;
    z-index: 1;
    padding: 0 4px;
    z-index: 9;
    line-height: 20px;
}
    .courseCardLabelTags:after {
    content: "";
    position: absolute;
    border-color: ${courseThemeCard1Object?.tags?.buttonBG?.colors?.color1} transparent ${courseThemeCard1Object?.tags?.buttonBG?.colors?.color1}
     ${courseThemeCard1Object?.tags?.buttonBG?.colors?.color1};
    border-style: solid;
    border-width: 10px;
    left: 100%;
    width: 0;
    height: 0;
    top: 0;
}

.courseCardCartDifficultyLabel,.courseCardCartLanguageLabel {
  font-size: 10px;;;padding: 5px 7px; margin-top: 8px;
    display: flex;justify-content: center;align-items: left;font-family: Montserrat !important;
height: 15px;border-radius: 5%;position: relative;z-index: 99 !important;
font-weight: 900;
animation-iteration-count: 1;animation-fill-mode:
    both;animation-name: animTwo;
}
.courseCardCartDifficultyLabel{
    color: #222;
}
.courseCardCartLanguageLabel{
    color: #222
}
.course-card-cart__title{
  margin: 0;
  font-size: 18px;
  line-height: 1.15;
  color: ${courseThemeCard1Object?.courseTitle?.titleColor?.color};
  font-family:${courseThemeCard1Object?.courseTitle?.titleFont?.family?.fontFamily};;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.course-card-cart__subtitle{
  margin: 6px 0 0;
  color: var(--muted);
  
  color: ${courseThemeCard1Object?.courseTitle?.subtitleColor?.color};
  font-family:${courseThemeCard1Object?.courseTitle?.subtitleFont?.family?.fontFamily};;
  font-size: 13px;
}

.course-card-cart__meta{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
}

.course-card-cart__meta-left{
  display: flex;
  gap: 12px;    color: ${courseThemeCard1Object?.courseTitle?.metaColor?.color};
 

}

.course-card-cart__meta-item{
  display: flex; 
  align-items: center;font-size:11px;
   font-family:${courseThemeCard1Object?.courseTitle?.metaFont?.family?.fontFamily};;
  gap: 5px;
}

.course-card-cart__rating{
  font-weight: 600; display:flex; justify-content:center;align-items:center;gap:5px;
   color: ${courseThemeCard1Object?.courseTitle?.metaColor?.color};
  font-size: 13px;  
   font-family:${courseThemeCard1Object?.courseTitle?.metaFont?.family?.fontFamily};;

}

.course-card-cart__progress{
  margin-top: 12px;
}

.course-card-cart__progress-row{
  display:flex;
  justify-content: space-between;
  font-size: 12px; 
  font-family:${courseThemeCard1Object?.courseTitle?.titleFont?.family?.fontFamily};;
  color: ${courseThemeCard1Object?.courseTitle?.metaColor?.color};
}

.course-card-cart__progress-bar{
  height: 8px;
  background: #eef2ff;
  border-radius: 999px;
  overflow: hidden;
  margin-top: 6px;
}

.course-card-cart__progress-fill{
  height: 100%;
  background: ${courseThemeCard1Object?.cardTheme?.cardThemeBG?.color};;
}

.course-card-cart__footer{
  margin-top: 0px;position:relative;
  display:flex;
  justify-content: space-between;
  align-items: center;
}

.course-card-cart__price{
  font-weight: 700;min-width:60px;
     color: ${courseThemeCard1Object?.courseTitle?.metaColor?.color};
  font-family:${courseThemeCard1Object?.courseTitle?.metaFont?.family?.fontFamily};;

}

.course-card-cart__lessons{
  font-size: 11px;
  
  color: ${courseThemeCard1Object?.courseTitle?.subtitleColor?.color};
   font-family:${courseThemeCard1Object?.courseTitle?.metaFont?.family?.fontFamily};;

}

.course-card-cart__cta{
  background: ${courseThemeCard1Object?.buyNowBtn?.btnBG?.color};
  color: ${courseThemeCard1Object?.buyNowBtn?.btnColor?.color};
    
  font-family:${courseThemeCard1Object?.courseTitle?.metaFont?.family?.fontFamily};;
 
  border:${courseThemeCard1Object?.buyNowBtn?.border?.borderWidth?.value}px ${courseThemeCard1Object?.buyNowBtn?.border?.borderType} ${courseThemeCard1Object?.buyNowBtn?.border?.borderColor?.color};
  
  ;font-size:12px;display:flex;justify-content:left;align-items:center;gap:2px;
  padding: 0px 0px;width:140px;border-radius:10px;
   font-weight: 700;
  cursor: pointer;
}

.course-card-cart__wishlist,.course-card-cart__cart{background: ${courseThemeCard1Object?.wishListCartBtn?.btnColor?.color?courseThemeCard1Object?.wishListCartBtn?.btnColor?.color:"#222222"};
  color: white;
  border:${courseThemeCard1Object?.wishListCartBtn?.border?.borderWidth?.value}px ${courseThemeCard1Object?.wishListCartBtn?.border?.borderType} ${courseThemeCard1Object?.wishListCartBtn?.border?.borderColor?.color};
  
  
           border-top-left-radius:${courseThemeCard1Object?.wishListCartBtn?.borderRadius?.topLeft?.value+"px"};
    border-bottom-left-radius:${courseThemeCard1Object?.wishListCartBtn?.borderRadius?.bottomLeft?.value+"px"};
    border-top-right-radius:${courseThemeCard1Object?.wishListCartBtn?.borderRadius?.topRight?.value+"px"};
    border-bottom-right-radius:${courseThemeCard1Object?.wishListCartBtn?.borderRadius?.bottomRight?.value+"px"};
 padding:5px;width:40px;height:40px;
 display:flex;justify-content:center;align-items:center;
  font-weight: 700;
  cursor: pointer;}
/* Responsive tweaks */
@media (max-width: 520px){
  .course-card-cart{ max-width: 100%;}
  .course-card-cart__media{ height: 160px; }
  .course-card-cart__title{ font-size: 16px; }
   .ty-cart-card{  position:relative;
             margin-left:0px;
          
        }
}
      .ty-cart-root{position:absolute;z-index:999999;top:0px;left:0px;right:0px;bottom:0px;;}
        .ty-cart-root{
          display:flex;align-items:center;justify-content:center;
          font-family: Arial, sans-serif;
          background:#f9fafb;
          color:#333;
          padding:0px;
        }
        .ty-cart-card{  position:relative;
          margin:10px;
          width:100%;display:flex;justify-content:center;
          border-radius:8px;
         
          text-align:center;
        }
        .ty-cart-icon{
          width:70px;height:70px; margin:0 auto 20px auto; border-radius:50%;
          background:#d1fae5; display:flex;align-items:center;justify-content:center;
        }
        .ty-cart-check{
          width:30px;height:15px; border-left:4px solid #10b981; border-bottom:4px solid #10b981;
          transform:rotate(-45deg);margin-top:-14px;
        }
        .ty-cart-title{font-size:22px;margin:0 0 10px 0;color:#111}
        .ty-cart-sub{margin:0 0 20px 0;font-size:15px;color:#555}
        .ty-cart-actions{display:flex;gap:12px;justify-content:center}
        .btn{
          padding:10px 18px; border:none; border-radius:6px; font-weight:600; cursor:pointer;
        }
           `}</style>
    </>
  );
}

